import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/apiClient";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setErr("");
        try {
            const { data } = await api.post("/auth/forgot-password", { email: email.trim() });
            setMsg(data.message || "If that email is registered, a reset link has been sent.");
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6" data-testid="forgot-page">
            <form onSubmit={submit} className="w-full max-w-sm" data-testid="forgot-form">
                <div className="font-serif text-2xl mb-1">Reset your password</div>
                <p className="text-sm text-zinc-500 mb-8">
                    Enter your account email. We'll send a one-time link that expires in 1 hour.
                </p>
                <label className="caption">Email</label>
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-email"
                    className="mt-2 mb-5 w-full bg-[#18181B] border border-white/10 rounded-md px-3 py-2.5 text-sm focus:border-[#D4AF37]/60"
                />
                {msg && (
                    <div className="mb-4 px-3 py-2 bg-[#5B8A62]/10 border border-[#5B8A62]/30 rounded-md text-sm text-[#B9DBB9]" data-testid="forgot-success">
                        {msg}
                    </div>
                )}
                {err && (
                    <div className="mb-4 px-3 py-2 bg-[#B95050]/10 border border-[#B95050]/30 rounded-md text-sm text-[#E8A5A5]" data-testid="forgot-error">
                        {err}
                    </div>
                )}
                <button
                    type="submit"
                    disabled={busy}
                    data-testid="forgot-submit"
                    className="w-full bg-[#D4AF37] text-[#0E0E10] font-medium px-4 py-2.5 rounded-md hover:bg-[#B3922E] disabled:opacity-50"
                >
                    {busy ? "Sending..." : "Send reset link"}
                </button>
                <div className="mt-6 text-center text-sm text-zinc-500">
                    <Link to="/login" className="text-[#D4AF37] hover:underline" data-testid="forgot-back-link">
                        Back to sign in
                    </Link>
                </div>
            </form>
        </div>
    );
}
